module.exports = __webpack_public_path__ + "templates/tripadvisor.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/tripadvisor/templates/tripadvisor.html
// module id = FeFc
// module chunks = 1